import { useRef } from "react";
import { motion, useScroll, useSpring } from "framer-motion";
import { ArrowRight, Phone } from "lucide-react";
import { COMPANY, STEPS } from "./data";
import { Reveal, SectionHead } from "./Reveal";
import { EASE, requestOffer } from "./scroll";

export const Process = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start 80%", "end 55%"] });
  const progress = useSpring(scrollYProgress, { stiffness: 80, damping: 24 });

  return (
    <section id="ablauf" aria-labelledby="ablauf-title" className="relative bg-paper py-24 text-ink sm:py-32 lg:py-40" data-testid="process-section">
      <div className="mx-auto max-w-[1440px] px-5 sm:px-8 lg:px-12">
        <SectionHead id="ablauf-title" tone="light" eyebrow="Ablauf" title={<>In fünf Schritten<br />zum neuen Dach.</>}
          intro="Klar strukturiert, transparent kommuniziert: Sie wissen zu jedem Zeitpunkt, was als Nächstes passiert." />
        <div ref={ref} className="relative mt-16 lg:mt-24">
          <div className="absolute bottom-0 left-[21px] top-0 w-px bg-ink/15 lg:bottom-auto lg:left-0 lg:right-0 lg:top-[21px] lg:h-px lg:w-auto" />
          <motion.div style={{ scaleY: progress }} className="absolute bottom-0 left-[21px] top-0 w-px origin-top bg-terra-ink lg:hidden" />
          <motion.div style={{ scaleX: progress }} className="absolute left-0 right-0 top-[21px] hidden h-px origin-left bg-terra-ink lg:block" />
          <ol className="grid gap-12 lg:grid-cols-5 lg:gap-8">
            {STEPS.map((s, i) => (
              <motion.li key={s.n} className="relative pl-16 lg:pl-0 lg:pt-20"
                initial={{ opacity: 0, y: 28 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.3 }}
                transition={{ duration: 0.8, ease: EASE, delay: i * 0.09 }} data-testid={`process-step-${s.n}`}>
                <span className="absolute left-0 top-0 grid h-11 w-11 place-items-center rounded-full border border-ink/20 bg-paper font-display text-base font-bold text-ink">{s.n}</span>
                <h3 className="font-display text-3xl font-bold uppercase leading-none">{s.title}</h3>
                <p className="mt-3 max-w-xs text-[0.95rem] leading-relaxed text-slate-700">{s.text}</p>
              </motion.li>
            ))}
          </ol>
        </div>
        <Reveal className="mt-16 flex flex-col gap-3 sm:flex-row lg:mt-20">
          <button type="button" onClick={() => requestOffer("Dachcheck & Beratung")} className="btn-primary btn-mega justify-center" data-testid="process-cta">
            Schritt 1 starten: Dachcheck anfragen <ArrowRight size={18} className="btn-arrow" />
          </button>
          <a href={COMPANY.phoneHref} className="btn-dark btn-mega justify-center" data-testid="process-phone"><Phone size={18} /> {COMPANY.phoneDisplay}</a>
        </Reveal>
      </div>
    </section>
  );
};
